import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { api } from '../../../services/api';
import './SentimentoPopup.css';
import img1 from './../../../../public/Images/1.png';
import img2 from './../../../../public/Images/2.png';
import img3 from './../../../../public/Images/3.png';
import img4 from './../../../../public/Images/4.png';
import img5 from './../../../../public/Images/5.png';

const sentimentos = [
    { id: 1, label: "", png: img1 },
    { id: 2, label: "", png: img2 },
    { id: 3, label: "", png: img3 },
    { id: 4, label: "", png: img4 },
    { id: 5, label: "", png: img5 },
];

export default function SentimentoPopup({ chapa, onClose }) {
    const [sentimentoSelecionado, setSentimentoSelecionado] = useState(null);
    const [observacao, setObservacao] = useState('');
    const [enviando, setEnviando] = useState(false);

    const enviarSentimento = () => {
        if (!sentimentoSelecionado) {
            Swal.fire("Atenção", "Escolha um sentimento antes de enviar.", "warning");
            return;
        }

        const dados = {
            chapa,
            sentimento: sentimentoSelecionado,
            texto: observacao
        };
        console.log(dados);
        api.post(`/usuario/sentimento/${chapa}`, dados)
            .then(() => {
                Swal.fire("Obrigado!", "Seu sentimento foi registrado.", "success").then(() => {
                    localStorage.setItem("sentimento",sentimentoSelecionado );     
                    onClose(); // <-- Só chama aqui após confirmação de sucesso
                });
            })
            .catch(() => {
                Swal.fire("Erro", "Não foi possível registrar seu sentimento.", "error");
            })
            .finally(() => {
                setEnviando(false);
            });
    
};

return (
    <Modal show centered onHide={onClose}>
        <Modal.Header >
            <Modal.Title>Como você está se sentindo hoje?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="sentimentos-container">
                {sentimentos.map((s) => (
                    <div key={s.id} className="sentimento-item" onClick={() => setSentimentoSelecionado(s.id)}>
                        <img
                            src={s.png}
                            alt={s.label}
                            className={`sentimento-img ${sentimentoSelecionado === s.id ? 'selected' : ''}`}
                        />
                        <div>{s.label}</div>
                    </div>
                ))}
            </div>

            <Form.Group className="mt-3">
                <Form.Label>Observação (opcional)</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    value={observacao}
                    onChange={e => setObservacao(e.target.value)}
                />
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" disabled={enviando} onClick={() => {
                Swal.fire("Aviso", "Você precisa registrar um sentimento para continuar.", "info");
            }}>
                Cancelar
            </Button>
            <Button variant="success" disabled={enviando} onClick={enviarSentimento}>
                {enviando ? "Enviando..." : "Enviar"}
            </Button>
        </Modal.Footer>
    </Modal>
);
}
